"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripSlashes = void 0;
const stripSlashes = text => text ? text.replaceAll('/', '') : '';
exports.stripSlashes = stripSlashes;